import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface ImportRelativityListRequest {
  workspaceId: number;
  listId: number;
  listName: string;
  caseId?: string; // Legacy: specific case
  matterId?: string; // 2.0: matter-level
  filenameFieldArtifactId?: number;
}

interface ImportRelativityListResponse {
  jobId: string;
  uploadId: string;
}

const useImportRelativityList = () => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation<ImportRelativityListResponse, Error, ImportRelativityListRequest>(
    async (data) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data: {
          listName: data.listName,
          ...(data.matterId ? { matterId: data.matterId } : {}),
          ...(data.caseId ? { caseId: data.caseId } : {}),
          ...(data.filenameFieldArtifactId !== undefined
            ? { filenameFieldArtifactId: data.filenameFieldArtifactId }
            : {}),
        },
      });

      const response = await fetch(
        `${APIBaseChronos}/api/relativity/workspaces/${data.workspaceId}/lists/${data.listId}/import`,
        fetchConfig,
      );

      if (!response.ok) {
        throw new Error(`Failed to start import: ${response.statusText}`);
      }

      return response.json();
    },
    {
      onError: (error) => {
        console.error('Failed to start Relativity import:', error);
      },
    },
  );
};

export default useImportRelativityList;
